// @ts-expect-error JS file
import { authLoaded } from 'crm_data/auth/AuthActions';
// adapted from https://git.hubteam.com/HubSpot/CRM/blob/b539f5c3df518fcb2de2cd277ab90fcf1c1e27b3/crm_data/static/js/setup/SetupData.js
export const legacySetupData = auth => {
  require('crm_data/gates/IsUngatedStore');
  require('crm_data/user/UserStore');
  require('crm_data/portal/PortalStore');
  authLoaded(auth);
};